import {
  SHOW_LOADING,
  ORGANIZATION_LIST_SUCCESS,
  ORGANIZATION_FAIL,
  CREATE_NEW_ORGANIZATION,
  SET_ORGANIZATION,
  RESET_ORGANISATION
} from "../constants/Organization";

const initState = {
  loading: false,
  message: "",
  organizations: [],
  data: null,
};

const organization = (state = initState, action) => {
  switch (action.type) {
    case ORGANIZATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        organizations: action.payload,
      };
    case SET_ORGANIZATION:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case RESET_ORGANISATION:
      return {
        loading: false,
        message: "",
        organizations: [],
        data: null,
      };
    case CREATE_NEW_ORGANIZATION:
      return {
        ...state,
        loading: false,
        organizations: [...state.organizations, action.payload],
      };
    case ORGANIZATION_FAIL:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
      };

    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    default:
      return state;
  }
};

export default organization;
